__webpack_require__.p = "https://attrezzapp.affarintech.com/";